import { FC, Fragment } from 'react';
import { push } from 'connected-react-router';
import { useSelector } from 'react-redux';
import { useAppDispatch } from 'hooks/useStore';
// Types
import UserRoles from 'types/UserRoles';
// Selectors
import { getGroupItem } from 'store/group/groupSelectors';
import { selectCurrentUser } from 'store/currentUser/currentUserSelectors';
// Components
import { IconButton } from 'components/Buttons';
// Icons
import { FaChevronRight, FaChevronLeft } from 'react-icons/fa';
// i18next
import { useTranslation } from 'react-i18next';

export const GroupToolbar:FC = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const currentUser = useSelector(selectCurrentUser);
  const groupItem = useSelector(getGroupItem);

  const isAdmin = currentUser?.groups.includes(UserRoles.Admin);
  const role = isAdmin ? 'admin' : 'owner';

  const handleBackToQuizzesList = () => dispatch(push(`/${role}/groups`));

  return (
    <h1 className="flex items-center text-xl font-bold text-white leading-6">
      <span
        className="hidden tablet:inline-block cursor-pointer"
        onClick={handleBackToQuizzesList}
      >{t('pages.groups.title')}</span>
      <IconButton
        className="flex justify-center items-center tablet:hidden mr-2"
        onClick={handleBackToQuizzesList}
      ><FaChevronLeft /></IconButton>
      <Fragment>
        <FaChevronRight className="hidden tablet:inline-block mx-2" />
        <span className="opacity-60">{groupItem?.name}</span>
      </Fragment>
    </h1>
  )
};
